import { BLACK, type Color, type Dir, type GameState, PHASE, WHITE } from './types';

export function cap(s: string): string {
  return s ? s[0].toUpperCase() + s.slice(1) : '';
}

export function opponentColor(c: Color): Color {
  return c === BLACK ? WHITE : BLACK;
}

export function dirName(d: Dir | null): string {
  if (!d) return '';
  if (d[0] === -1) return 'up';
  if (d[0] === 1) return 'down';
  if (d[1] === -1) return 'left';
  return 'right';
}

export function dirArrow(d: Dir | null): string {
  if (!d) return '';
  if (d[0] === -1) return '↑';
  if (d[0] === 1) return '↓';
  if (d[1] === -1) return '←';
  return '→';
}

export function turnLabel(s: GameState): string {
  switch (s.phase) {
    case PHASE.OVER:
      return s.winner ? `${cap(s.winner)} Wins!` : 'Game Over';
    case PHASE.SETUP_B:
    case PHASE.SETUP_W:
      return `${cap(s.turn)}'s Setup`;
    case PHASE.MULTI:
      return `${cap(s.turn)} — Multi-capture`;
    case PHASE.SELECT:
    case PHASE.CAPTURE:
      return `${cap(s.turn)}'s Turn`;
    default:
      return '';
  }
}

/**
 * One sentence of guidance tailored to the current phase. Written for
 * middle-school readers — short, concrete, refers to the on-screen highlights.
 */
export function instructionLabel(s: GameState): string {
  switch (s.phase) {
    case PHASE.SETUP_B:
      return 'Black starts. Tap any glowing square to remove that stone — a center square or a corner.';
    case PHASE.SETUP_W:
      return 'White removes a stone next to where Black just removed. Tap a glowing square.';
    case PHASE.SELECT:
      return 'Tap one of your glowing stones, then jump over an opponent into an empty square.';
    case PHASE.CAPTURE:
      return 'Tap a teal dot to capture. Tap your stone again to pick a different one.';
    case PHASE.MULTI: {
      const arrow = dirArrow(s.dir);
      const name = dirName(s.dir);
      return `You can keep jumping ${arrow} ${name} (orange dots), or press End Turn to stop.`;
    }
    case PHASE.OVER: {
      const loser = s.winner ? opponentColor(s.winner) : null;
      return loser ? `${cap(loser)} has no jumps left.` : '';
    }
    default:
      return '';
  }
}
